import { Link } from 'react-router-dom'
import Logo from '../../assets/images/footer-logo.svg'
import PhoneIcon from '../../assets/icons/phone-icon.svg'
import PinIcon from '../../assets/icons/pin-icon.svg'
import MailIcon from '../../assets/icons/mail-icon.svg'
import FbIcon from '../../assets/icons/fb.svg'
import Button from '../Button/Button.js'
import { BOOKING_URL, CONTACT_DETAILS } from '../../constants/site.js'

function Footer() {
  const { address, email, phoneNumbers } = CONTACT_DETAILS

  return (
    <footer className='relative w-full overflow-hidden bg-blue-dark px-6 pt-[60px] text-white md:px-0'>
      <div className='absolute left-0 top-0 w-full overflow-hidden leading-none'>
        <svg
          className='relative block h-[60px] w-[calc(100%+1.3px)]'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1200 120'
          preserveAspectRatio='none'
        >
          <path
            d='M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z'
            className='fill-white'
          ></path>
          <path
            d='M0,0V56.29c57.79,32.2,123.59,42.17,188,38,80.36-7.37,156.33-43.31,236.8-47.5C508.64,42.43,592.34,73.67,673,92.05c79.27,23,158.3,29.88,239.4,18.08,46.15-8,89.85-22.84,134.45-34.34C1149.49,40,1283,-4.29,1200,72.47V0Z'
            fill='rgba(255,255,255,0.5)'
          ></path>
        </svg>
      </div>

      <div className='container'>
        <div className='grid grid-cols-1 gap-y-8 py-12 sm:grid-cols-2 md:grid-cols-3'>
          <div className='hidden md:block'>
            <Link to='/' className='mb-3 flex items-center'>
              <img src={Logo} alt='' />
            </Link>
          </div>

          <div>
            <h2 className='mb-4 text-lg font-semibold'>LET'S TALK</h2>
            <p className='mb-4 text-sm'>If you are unsure whether Osteopathy is right for you contact us.</p>

            <div className='mb-2 flex items-start'>
              <img className='mr-4' src={PhoneIcon} alt='' />
              <div>
                {phoneNumbers.map((phoneNumber) => (
                  <p className='text-sm' key={phoneNumber.label}>
                    {phoneNumber.label}: {phoneNumber.number}
                  </p>
                ))}
              </div>
            </div>

            <div className='mb-2 flex items-start'>
              <img className='mr-4' src={MailIcon} alt='' />
              <p className='text-sm'>{email}</p>
            </div>

            <div className='flex items-start'>
              <img className='mr-4' src={PinIcon} alt='' />
              <div>
                <p className='text-sm'>{address.location}</p>
                <p className='text-sm'>
                  {address.street}, {address.city}
                </p>
              </div>
            </div>
          </div>

          <div>
            <h2 className='mb-4 text-lg font-semibold'>AVAILABLE HOURS</h2>
            <p className='text-sm'>
              <strong>MONDAY - FRIDAY</strong>
            </p>
            <p className='mb-4 text-sm'>9:00AM - 3:00PM</p>
            <Button label='BOOK NOW' buttonType='tertiary' navigateExternal={BOOKING_URL} />
            <div className='mt-3 flex items-center'>
              <a
                href='https://www.facebook.com/profile.php?id=61564912253194'
                target='_blank'
                rel='noreferrer'
              >
                <img className='mr-4' src={FbIcon} alt='' />
              </a>
              <p>Follow us</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
